const audienceDefaultState = {
  audienceId: null,
  audienceName: '',
  audienceEmoji: '',
  audienceQuizTeam: null,
  isAudienceEmojiDisabled: false,
  audienceEmail: '',
  audienceTeam: '',
  offsetTime: 0,
}

export default audienceDefaultState
